// React Imports
import { Fragment, ReactElement, useEffect, useState } from "react";

// Third Party Libraries Imports
import ReactQuill from "react-quill";
import TabPane from "antd/es/tabs/TabPane";
import { Button, Form, Select, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { MinusCircleOutlined, PlusSquareOutlined } from "@ant-design/icons";

// Style Imports
import "./add-card.scss";

// Local Imports
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import Label from "../../components/label/label.component";
import CustomInput from "../../components/custom-input/custom-input.component";

const { Option } = Select;

const AddCard: React.FC = (): ReactElement => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submitLoginForm, setSubmitLoginForm] = useState(false);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmitLoginForm(true);
      },
      () => {
        setSubmitLoginForm(false);
      }
    );
  }, [values]);

  return (
    <section className="add-card-container flex flex-col">
      <BreadcrumbComponent />
      <div className="flex flex-col bg-white p-[2%] rounded-[20px]">
        <h3 className=" text-black-500 text-base font-semibold border-b-[1px] border-gray-900 pb-3 mb-5">
          Create a new card
        </h3>
        <Form form={form} className="flex flex-col flex-wrap justify-between">
          <div className="flex-col w-full md:w-[35%]">
            <Label text="Action card title" />
            <Form.Item
              name="Enter Action card title"
              rules={[
                {
                  required: true,
                  message: "Please input Action card title!",
                },
              ]}
            >
              <CustomInput placeholder="Enter Action card title" />
            </Form.Item>
          </div>

          <div className="flex-col w-full md:w-[35%]">
            <Label text="Customers" />
            <Form.Item
              name="Customers"
              rules={[
                {
                  required: true,
                  message: "Please slect Customers!",
                },
              ]}
            >
              <Select showSearch allowClear placeholder="Select Customers">
                {Array.from({ length: 100 }, (_, index) => index + 1).map(
                  (item) => (
                    <Option value={item} key={item}>
                      <span>{item}</span>
                    </Option>
                  )
                )}
              </Select>
            </Form.Item>
          </div>
          <div className="tabs flex flex-col w-full">
            <Label text="Action card message" />
            <div className="flex flex-col">
              <Tabs type="card">
                <TabPane tab="English" key="1">
                  <Form.Item
                    name="disclaimerEn"
                    rules={[
                      {
                        required: true,
                        message: "Please input english terms and conditions!",
                      },
                    ]}
                  >
                    <ReactQuill
                      theme="snow"
                      placeholder="Enter action card message in English"
                    />
                  </Form.Item>
                </TabPane>
                <TabPane tab="Arabic" key="2">
                  <Form.Item
                    name="disclaimerAr"
                    rules={[
                      {
                        required: true,
                        message: "Please input arabic terms and conditions!",
                      },
                    ]}
                  >
                    <ReactQuill
                      theme="snow"
                      placeholder="Enter action card message in Arabic"
                    />
                  </Form.Item>
                </TabPane>
              </Tabs>
            </div>

            <div className="flex flex-col justify-between w-full">
              <Form.List
                name="strategies"
                initialValue={[]}
                rules={[
                  {
                    validator: async (_, names) => {
                      if (!names) {
                        return Promise.reject(new Error("At least 1 variable"));
                      }
                    },
                  },
                ]}
              >
                {(fields: any = 1, { add, remove }, { errors }) => (
                  <Form.Item>
                    <div className="flex flex-col justify-between flex-wrap">
                      <div className="flex justify-between flex-wrap">
                        {fields.map((field: any, index: any) => (
                          <Fragment key={index}>
                            <div className="flex flex-col flex-wrap justify-between w-full">
                              <div className="flex items-start flex-wrap justify-between">
                                <div className="flex flex-col w-full md:w-[32%] ">
                                  <Label text={"Button title"} />
                                  <Form.Item
                                    {...field}
                                    name={[field.name, `Variable${index}`]}
                                    validateTrigger={["onChange", "onBlur"]}
                                    rules={[
                                      {
                                        required: true,
                                        whitespace: true,
                                        message: "Please input Variable",
                                      },
                                    ]}
                                  >
                                    <CustomInput placeholder="Enter button title" />
                                  </Form.Item>
                                </div>
                                <div className="flex flex-col w-full md:w-[32%] ">
                                  <Label text={"Deep link"} />
                                  <Form.Item
                                    {...field}
                                    name={[field.name, `Variable${index}`]}
                                    validateTrigger={["onChange", "onBlur"]}
                                    rules={[
                                      {
                                        required: true,
                                        whitespace: true,
                                        message: "Please input Variable",
                                      },
                                    ]}
                                  >
                                    <CustomInput placeholder="Enter deep link" />
                                  </Form.Item>
                                </div>
                                <div className="flex flex-col w-full md:w-[32%] ">
                                  <Label text={"Button type"} />
                                  <Form.Item
                                    {...field}
                                    name={[field.name, `Variable${index}`]}
                                    validateTrigger={["onChange", "onBlur"]}
                                    rules={[
                                      {
                                        required: true,
                                        whitespace: true,
                                        message: "Please input Variable",
                                      },
                                    ]}
                                  >
                                    <Select
                                      showSearch
                                      allowClear
                                      placeholder="Select button type"
                                    ></Select>
                                  </Form.Item>
                                </div>
                              </div>
                              {fields.length > 1 ? (
                                <Button
                                  className="flex items-center w-full justify-end text-red-600 border-0 bg-transparent mb-2 shadow-none p-0"
                                  onClick={() => remove(field.name)}
                                >
                                  <MinusCircleOutlined />
                                  Delete
                                </Button>
                              ) : null}
                            </div>
                          </Fragment>
                        ))}
                      </div>
                      <Form.Item>
                        <div className="add-field-button flex justify-start w-full">
                          <Button
                            onClick={() => add()}
                            className=" border-0 text-blue-500 bg-transparent mb-2 shadow-none p-0 text-base"
                            icon={<PlusSquareOutlined />}
                          >
                            Add a button
                          </Button>
                        </div>
                        <Form.ErrorList errors={errors} />
                      </Form.Item>
                    </div>
                  </Form.Item>
                )}
              </Form.List>
            </div>
          </div>

          <div className="flex w-full flex-wrap items-center justify-between mt-11 border-t-[1px] border-gray-900 pt-5">
            <div className="flex w-[28%] md:w-[48%]">
              <span
                className=" cursor-pointer underline text-gray-500"
                onClick={() => form.resetFields()}
              >
                Reset to default
              </span>
            </div>
            <div className="flex justify-between items-center w-[70%] md:w-[48%]">
              <button
                type="button"
                className="rounded-lg bg-white w-[48%] py-3 text-center outline-0 cursor-pointer text-sm font-semibold border-[1px] border-blue-500 text-blue-500"
                onClick={() => navigate("/funds")}
              >
                Cancel
              </button>
              <button
                className="rounded-lg bg-blue-500 w-[48%] py-3 text-center outline-0 cursor-pointer text-sm font-semibold border-[1px] border-blue-500 text-white disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={!submitLoginForm}
              >
                Submit
              </button>
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default AddCard;
